module.exports = __webpack_public_path__ + "img/film-slash.1ad61621.svg";